<template>
  <div>
    <v-dialog v-model="value" max-width="1200" @keydown.esc="$emit('input', false)" @click:outside="$emit('input', false)"
      content-class="dialog-search-booking">
      <v-card outlined>
        <v-card-title :class="`align-center white--text py-2`" 
          :style="`background-color: ${bookingTab == 1 ? 'var(--monthly-booking-base)' : 'var(--daily-booking-base)'}`"
        >
          <div>{{ $t('area.book_empty_stall') }} {{ bookingTab == 0 ? $t('daily') : $t('monthly') }}</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-tabs v-model="bookingTab" grow @change="changeBookingType()" :color="bookingTab == 1 ? 'blue' : 'green'">
          <v-tab value="daily">{{ $t('daily') }}</v-tab>
          <v-tab value="monthly">{{ $t('monthly') }}</v-tab>
        </v-tabs>
        <div class="p-5">
          <v-row v-if="bookingTab == 0">
            <v-col cols="3">
              <v-menu ref="menu_start_date" v-model="formData.isStartDate" :close-on-content-click="false"
                :return-value.sync="formData.startDate" transition="scale-transition" offset-y min-width="auto"
                :disabled="isLoadSearch">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="$helper.datelabel(formData.startDate)" :label="$t('area.enter_stall_date')"
                    prepend-inner-icon="mdi-calendar" readonly outlined v-bind="attrs" v-on="on" hide-details
                    :disabled="isLoadSearch" dense></v-text-field>
                </template>
                <v-date-picker v-model="formData.startDate" no-title scrollable locale="th"
                  :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                  :min="$moment().format('YYYY-MM-DD')" persistent-hint :disabled="isLoadSearch"
                  :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="formData.isStartDate = false" :disabled="isLoadSearch">{{ $t('cancel') }}</v-btn>
                  <v-btn text color="success" :disabled="isLoadSearch"
                    @click="$refs.menu_start_date.save(formData.startDate); dateStartChange()">{{ $t('confirm') }}</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2">
              <v-select class="text-center" prepend-inner-icon="mdi-clock-outline" :label="$t('time')" outlined
                v-model="formData.startTime" @input="dateStartChange()" :items="$helper.timeLabel().hoursMinutes"
                :disabled="isLoadSearch" hide-details dense :no-data-text="$t('noinfo')"></v-select>
            </v-col>
            <v-col cols="2" class="text-center align-center mt-2 text-lg">{{ $t('to') }}</v-col>
            <v-col cols="3">
              <v-menu ref="menu_end_date" v-model="formData.isEndDate" :close-on-content-click="false"
                :return-value.sync="formData.endDate" transition="scale-transition" offset-y min-width="auto"
                :disabled="isLoadSearch">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="$helper.datelabel(formData.endDate)" :label="$t('area.exit_stall_date')"
                    prepend-inner-icon="mdi-calendar" readonly outlined v-bind="attrs" v-on="on" :disabled="isLoadSearch"
                    hide-details dense></v-text-field>
                </template>
                <v-date-picker v-model="formData.endDate" no-title scrollable locale="th"
                  :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                  :min="formData.startDate" persistent-hint :disabled="isLoadSearch"
                  :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="formData.isEndDate = false" :disabled="isLoadSearch">{{ $t('cancel') }}</v-btn>
                  <v-btn text color="success" :disabled="isLoadSearch"
                    @click="$refs.menu_end_date.save(formData.endDate); dateStartChange()">{{ $t('confirm') }}</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2">
              <v-select class="text-center" prepend-inner-icon="mdi-clock-outline" :label="$t('time')" outlined
                @input="dateStartChange()()" v-model="formData.endTime" :items="$helper.timeLabel().hoursMinutes"
                :disabled="isLoadSearch" hide-details dense :no-data-text="$t('noinfo')"></v-select>
            </v-col>
          </v-row>
          <v-row v-if="bookingTab == 1">
            <v-col cols="5">
              <v-menu ref="menu_start_date" v-model="formData.isStartDate" :close-on-content-click="false"
                :return-value.sync="formData.startDate" transition="scale-transition" offset-y min-width="auto"
                :disabled="isLoadSearch">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="$helper.datelabel(formData.startDate)" :label="$t('contract.start_contract_date')"
                    prepend-inner-icon="mdi-calendar" readonly outlined v-bind="attrs" v-on="on" hide-details
                    :disabled="isLoadSearch" dense></v-text-field>
                </template>
                <v-date-picker v-model="formData.startDate" no-title scrollable locale="th"
                  :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat" persistent-hint
                  :disabled="isLoadSearch" :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="formData.isStartDate = false" :disabled="isLoadSearch">{{ $t('cancel') }}</v-btn>
                  <v-btn text color="success" :disabled="isLoadSearch"
                    @click="$refs.menu_start_date.save(formData.startDate); dateStartChange()">{{ $t('confirm') }}</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2" class="text-center align-center mt-2 text-lg">{{ $t('to') }}</v-col>
            <v-col cols="5">
              <v-menu ref="menu_end_date" v-model="formData.isEndDate" :close-on-content-click="false"
                :return-value.sync="formData.endDate" transition="scale-transition" offset-y min-width="auto"
                :disabled="isLoadSearch">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="$helper.datelabel(formData.endDate)" :label="$t('contract.end_contract_date')"
                    prepend-inner-icon="mdi-calendar" readonly outlined v-bind="attrs" v-on="on" :disabled="isLoadSearch"
                    hide-details dense></v-text-field>
                </template>
                <v-date-picker v-model="formData.endDate" no-title scrollable locale="th"
                  :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                  :min="formData.startDate" persistent-hint :disabled="isLoadSearch"
                  :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth">
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="formData.isEndDate = false" :disabled="isLoadSearch">{{ $t('cancel') }}</v-btn>
                  <v-btn text color="success" :disabled="isLoadSearch"
                    @click="$refs.menu_end_date.save(formData.endDate); dateStartChange()">{{ $t('confirm') }}</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-btn class="mt-4 white--text" block @click="search()"
            :style="`background-color: ${bookingTab == 1 ? 'var(--monthly-booking-base)' : 'var(--daily-booking-base)'}`"
          >
            <v-icon left>mdi-magnify</v-icon>{{ $t('area.search_available_area') }}
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="dialog-search-booking-in overflow-y-auto">
          <div v-if="vacancyAreas" class="mt-3">
            <h3 class="text-center" v-if="bookingTab == 0">
              <b>{{ $t('area.available_area_date') }}</b>
              {{ $moment(`${tempDate.startDate} ${tempDate.startTime}`, "YYYY-MM-DD HH:mm").format("DD MMMM YYYY HH:mm")
              }} -
              {{ $moment(`${tempDate.endDate} ${tempDate.endTime}`, "YYYY-MM-DD HH:mm").format("DD MMMM YYYY HH:mm") }}
            </h3>
            <h3 class="text-center" v-if="bookingTab == 1">
              <b>{{ $t('area.available_area_date') }}</b>
              {{ $moment(tempDate.startDate).format("DD MMMM YYYY") }} -
              {{ $moment(tempDate.endDate).format("DD MMMM YYYY") }}
            </h3>
          </div>
          <div class="filter-area-box" v-if="vacancyAreas">
            <div v-if="viewType == 'table'">
              <span class="text-areas">({{ currentVacancyAreas && currentVacancyAreas.length ? `${$t('area.available_area_count', { count: currentVacancyAreas.length })}`
                :
                $t('area.no_available_area') }})</span>
              <v-chip-group v-model="filterArea">
                <v-icon class="mb-2 mr-2"
                  :color="filterArea == 'isAvailable' ? 'success' : filterArea == 'isSuspend' ? 'warning' : filterArea == 'isOutContract' ? 'info' : filterArea == 'isInContract' ? 'error' : 'black'">mdi-filter-variant</v-icon>
                <v-chip :outlined="filterArea != 'All'" class="mb-2 mr-2" value="All">{{ $t('all') }}</v-chip>
                <v-chip color="success" :outlined="filterArea != 'isAvailable'" class="mb-2 mr-2"
                  value="isAvailable">{{ $t('area.empty_stall') }}</v-chip>
                <v-chip color="warning" :outlined="filterArea != 'isSuspend'" class="mb-2 mr-2"
                  value="isSuspend">{{ $t('area.parking_area') }}</v-chip>
                <v-chip color="info" :outlined="filterArea != 'isOutContract'" class="mb-2 mr-2"
                  value="isOutContract">{{ $t('contract.not_available_stall_out_of_contract') }}</v-chip>
                <v-chip color="error" :outlined="filterArea != 'isInContract'" class="mb-2 "
                  value="isInContract">{{ $t('contract.not_available_stall_in_contract') }}</v-chip>
              </v-chip-group>
            </div>
            <div v-else></div>
            <v-btn-toggle v-model="viewType" mandatory dense @change="selectAreas = []">
              <v-btn value="table">{{ $t('table') }}</v-btn>
              <v-btn value="plan">{{ $t('area.market_plan') }}</v-btn>
            </v-btn-toggle>
          </div>
          <div class="text-right d-block" v-if="vacancyAreas">
            <v-divider></v-divider>
            <v-data-table
              v-if="viewType == 'table'"
              v-model="selectAreas"
              :headers="areaTable.headers"
              :items="areaTable.items"
              :footer-props="{
                'items-per-page-text': ' ',
              }"
              :items-per-page="13"
              :loading="isLoadSearch"
              item-key="objectId"
              show-select
              :single-select="false"
              :no-data-text="$t('noinfo')"
              :no-results-text="$t('no_matching_records_found')">
              <template v-slot:item.name="{ item }">
                <v-chip v-if="item.statusBooking" :color="item.statusBooking.color" outlined>
                  <v-icon left>{{ item.statusBooking.icon }}</v-icon>
                  {{ item.statusBooking.text }}</v-chip>
              </template>
            </v-data-table>
            <MarketPlan v-if="!isLoadSearch && !isLoading && viewType == 'plan'" :isEdit="false" :height="height"
              :selectAreas.sync="selectAreas" :isSelect="true" :vacancyAreas="vacancyAreas"
              :areaBookings="areaBookings" 
              :summaryData="{booking : summaryData.booking, invoice : summaryData.invoice}"
              :tooltipStallId="'tooltipStallId2'"
              :isBooking="true"
            />
          </div>
          <div v-if="!vacancyAreas && !isLoading && !isLoadSearch" style="font-size:18px;"
            class="text-gray-300 w-100 text-center p-10">{{ $t('noinfo') }}</div>
          <v-overlay absolute v-if="isLoading || isLoadSearch" opacity="0.5" color="white">
            <v-progress-circular indeterminate color="green" size="70"></v-progress-circular>
          </v-overlay>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('input', false)" color="error">{{ $t('close') }}</v-btn>
          <v-btn @click="onBooking()" color="primary" :disabled="!selectAreas.length">{{ $t('booked') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <BookingDialog v-model="isBookingDialog" :marketId="marketId" :projectId="projectId"
      :type="bookingTab == 0 ? 'daily' : 'monthly'" :areaBookings="areaBookings" :booking="booking"
      @createBookingSuccess="createBookingSuccess" />
  </div>
</template>

<script>
import MarketPlan from "../components/MarketPlan.vue";
import BookingDialog from "../components/BookingDialog.vue";
export default {
  props: {
    value: Boolean,
    marketId: String,
    projectId: String,
    summaryData: Object,
  },
  components: {
    MarketPlan,
    BookingDialog
  },
  data() {
    return {
      isLoading: false,
      isLoadSearch: false,
      isEdit: false,
      bookingTab: 0,
      formData: {
        isStartDate: false,
        startDate: this.$moment().format("YYYY-MM-DD"),
        startTime: "08:00",
        isendDate: false,
        endDate: this.$moment().format("YYYY-MM-DD"),
        endTime: "20:00"
      },
      tempDate: null,
      selectAreas: [],
      viewType: "table",
      vacancyAreas: null,
      areaBookings: [],
      isBookingDialog: false,
      areaBookings: [],
      booking: null,
      height: 0,
      filterArea: 'All',
    };
  },
  watch: {
    value(value) {
      if (value) {
        this.booking = null;
        this.height = document.documentElement.clientHeight - 457;
      }

      this.selectAreas = [];
      this.vacancyAreas = null;
      this.areaBookings = [];
      this.viewType = "table";
      this.bookingTab = 0;
      this.formData = {
        isStartDate: false,
        startDate: this.$moment().format("YYYY-MM-DD"),
        startTime: "08:00",
        isendDate: false,
        endDate: this.$moment().format("YYYY-MM-DD"),
        endTime: "20:00"
      };
    }
  },
  computed: {
    areaTable() {
      return {
        headers: [
          {
            text: this.$t('area.area_name'),
            value: "name",
            width: "80%"
          },
          {
            text: this.$t('area.area_size_square_meter'),
            value: "size"
          }
        ],
        items: this.currentVacancyAreas
      };
    },
    currentVacancyAreas() {
      let currentVacancyAreas = []
      if (this.filterArea == 'All') {
        currentVacancyAreas = this.vacancyAreas
      } else if (this.filterArea == 'isAvailable') {
        currentVacancyAreas = this.vacancyAreas.filter(a => a.statusBooking && a.statusBooking.isAvailable)
      } else if (this.filterArea == 'isSuspend') {
        currentVacancyAreas = this.vacancyAreas.filter(a => a.statusBooking && a.statusBooking.isSuspend)
      } else if (this.filterArea == 'isOutContract') {
        currentVacancyAreas = this.vacancyAreas.filter(a => a.statusBooking && a.statusBooking.isOutContract)
      } else if (this.filterArea == 'isInContract') {
        currentVacancyAreas = this.vacancyAreas.filter(a => a.statusBooking && a.statusBooking.isInContract)
      } else {
        this.filterArea = 'All'
        currentVacancyAreas = this.vacancyAreas
      } 
      return currentVacancyAreas
    }
  },
  methods: {
    changeBookingType() {
      this.isLoading = true;
      setTimeout(() => {
        this.selectAreas = [];
        this.vacancyAreas = null;
        this.areaBookings = [];
        this.viewType = "table";
        this.isLoading = false;
        this.formData = {
          isStartDate: false,
          startDate: this.$moment().format("YYYY-MM-DD"),
          startTime: "08:00",
          isendDate: false,
          endDate: this.$moment().format("YYYY-MM-DD"),
          endTime: "20:00"
        };
        if (this.bookingTab == 1) {
          this.formData.endDate = this.$moment()
            .add(1, "month")
            .format("YYYY-MM-DD");
        }
      }, 200);
    },
    async search() {
      this.isLoadSearch = true;
      this.selectAreas = [];
      this.viewType = "table";
      try {
        let startDate, endDate;
        if (this.bookingTab == 0) {
          startDate = this.$moment(
            `${this.formData.startDate} ${this.formData.startTime}`,
            "YYYY-MM-DD HH:mm"
          ).toDate();
          endDate = this.$moment(
            `${this.formData.endDate} ${this.formData.endTime}`,
            "YYYY-MM-DD HH:mm"
          ).toDate();
        } else {
          startDate = this.$moment(this.formData.startDate, "YYYY-MM-DD")
            .startOf("day")
            .toDate();
          endDate = this.$moment(this.formData.endDate, "YYYY-MM-DD")
            .endOf("day")
            .toDate();
        }
        this.tempDate = JSON.parse(JSON.stringify(this.formData));
        this.vacancyAreas = await this.$store.dispatch(
          "area/getAvailableAreas",
          {
            marketId: this.marketId,
            startDate,
            endDate,
            type: this.bookingTab == 0 ? "daily" : "monthly"
          }
        ) || [];
        this.areaBookings = await this.$store.dispatch(
          "areaBooking/getAreaBookingBetweenDate",
          {
            marketId: this.marketId,
            startDate,
            endDate
          }
        );
        this.isLoadSearch = false;
      } catch (err) {
        this.isLoadSearch = false;
      }
    },
    onBooking() {
      let startDate, endDate;
      if (this.bookingTab == 0) {
        startDate = this.$moment(
          `${this.tempDate.startDate} ${this.tempDate.startTime}`,
          "YYYY-MM-DD HH:mm"
        ).toDate();
        endDate = this.$moment(
          `${this.tempDate.endDate} ${this.tempDate.endTime}`,
          "YYYY-MM-DD HH:mm"
        ).toDate();
      } else {
        startDate = this.$moment(this.tempDate.startDate, "YYYY-MM-DD")
          .startOf("day")
          .toDate();
        endDate = this.$moment(this.tempDate.endDate, "YYYY-MM-DD")
          .endOf("day")
          .toDate();
      }
      this.areaBookings = [];
      for (let area of this.selectAreas) {
        this.areaBookings.push({
          startDate,
          endDate,
          area
        });
      }
      this.booking = null;
      this.isBookingDialog = true;
    },
    dateStartChange() {
      let dataArea = this.formData;
      let momentSatrtDate = this.$moment(
        `${dataArea.startDate} ${dataArea.startTime}`,
        "YYYY-MM-DD HH:mm"
      );
      let momentEndDate = this.$moment(
        `${dataArea.endDate} ${dataArea.endTime}`,
        "YYYY-MM-DD HH:mm"
      );
      if (momentEndDate.isBefore(momentSatrtDate)) {
        let nextDay =
          this.bookingTab == 0
            ? momentSatrtDate.add(12, "hours")
            : this.bookingTab == 1
              ? momentSatrtDate.add(1, "months")
              : null;
        if (nextDay) dataArea.endDate = nextDay.format("YYYY-MM-DD");
      }
    },
    async createBookingSuccess(booking) {
      if (booking) {
        this.booking = booking;
      } else {
        this.booking = null;
      }
      if (this.booking && this.booking.objectId) {
        this.booking = await this.$store.dispatch(
          "booking/getBooking",
          this.booking.objectId
        );
        await this.search();
      }
      this.$emit("onSuccess", true);
    },
    checkExpired(date) {
      let isExpired = false;
      if (date && date.iso) {
        isExpired = this.$moment().isAfter(this.$moment(date.iso));
      } else if (date) {
        isExpired = this.$moment().isAfter(this.$moment(date));
      }
      return isExpired;
    },
   
  }
};
</script>

<style lang="scss" scoped>
.dialog-search-booking.v-dialog .dialog-search-booking-in.v-card__text::v-deep {
  height: 600px;
  max-height: calc(90vh - 65px - 64px - 156px);
}

.filter-area-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
</style>
